import compose from 'lodash/fp/compose';
import fromPairs from 'lodash/fromPairs';

import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import { addQuoteLine } from '../actions';
import { connectEditor } from '../connect-editor';
import initializeQuoteLineFrom from '../utils/initialize-quote-line';
import QuoteLineBundleSelection from './QuoteLineBundleSelection';

function transformCountrySplit(bundleLineCountrySplit) {
  return fromPairs(
    bundleLineCountrySplit.map(({ countryCode, share }) => [
      countryCode,
      share,
    ]),
  );
}

function buildQuoteLine(opportunity, quote, productsById, bundleLine) {
  return {
    ...initializeQuoteLineFrom(
      quote,
      productsById[bundleLine.productId],
      opportunity,
    ),
    countrySplit: transformCountrySplit(bundleLine.countrySplit),
    netClientBudget:
      bundleLine.netClientBudget ||
      opportunity.budgets.netClientBudget * bundleLine.netClientBudgetShare,
    pricing: bundleLine.pricing,
    startDate: bundleLine.startDate,
    endDate: bundleLine.endDate,
    categories: bundleLine.categories,
  };
}

export default compose(
  connectEditor(
    ({ opportunity, productsById, quote }) => ({
      opportunity,
      productsById,
      quote,
    }),
    { addQuoteLine },
    (
      { opportunity, productsById, quote },
      { addQuoteLine: dispatchAddQuoteLine },
    ) => ({
      onSelect: bundle => {
        bundle.lines.forEach(line => {
          dispatchAddQuoteLine(
            buildQuoteLine(opportunity, quote, productsById, line),
          );
        });
      },
    }),
  ),
  withResolved({
    query: api.getQuoteLineBundles,
    as: 'bundles',
  }),
)(QuoteLineBundleSelection);
